export default "__VITE_ASSET__SUR5bUeX__"